export default {
  subtitle:
    "Análisis profundo del cumplimiento de carbono de la UE-CBAM para ayudar a las PYME a comprender rápidamente las regulaciones y tendencias del mercado",
  feature1: "Introducción a la CBAM",
  feature2: "Proceso de cumplimiento",
  feature3: "Tendencias del mercado",
  feature4: "Cómo nuestro producto ayuda a las empresas",
  seo_title: "Guía de cumplimiento de carbono de la UE-CBAM",
  section1_title: "Introducción a la CBAM",
  section1_content1:
    "El Mecanismo de Ajuste Fronterizo de Carbono (CBAM) de la UE es un instrumento político importante que la UE ha introducido para combatir el cambio climático.",
  section1_content2:
    "Este mecanismo tiene como objetivo prevenir la fuga de carbono y garantizar que las mercancías importadas estén en un entorno competitivo justo con las mercancías producidas dentro de la UE en términos de costos de emisiones de carbono.",
  section1_content3:
    "La CBAM requiere que los importadores de ciertas mercancías intensivas en carbono a la UE compren los certificados de emisiones de carbono correspondientes que reflejen los costos de carbono soportados por los productores de la UE.",
  section2_title: "Proceso de cumplimiento",
  section2_content: "El proceso de cumplimiento de la CBAM incluye cuatro pasos clave:",
  section2_step1:
    "Declaración: Los importadores deben registrarse en el sistema CBAM y declarar periódicamente las emisiones de carbono de las mercancías importadas",
  section2_step2:
    "Verificación: Los datos de emisiones de carbono declarados deben ser verificados por una agencia de auditoría independiente",
  section2_step3:
    "Compra de certificados: Comprar los certificados CBAM correspondientes basados en los datos de emisiones verificados",
  section2_step4:
    "Aduanas: Las mercancías solo pueden ingresar al mercado de la UE después de completar la compra de certificados CBAM",
  section3_title: "Tendencias del mercado",
  section3_content:
    "La CBAM continúa desarrollándose y expandiéndose, con las siguientes tendencias principales:",
  section3_trend1:
    "Expansión del alcance: La CBAM se expandirá gradualmente a más industrias, incluyendo productos químicos orgánicos y plásticos",
  section3_trend2:
    "Estándares más estrictos: La UE continuará mejorando los requisitos de precisión y transparencia en el conteo de emisiones de carbono",
  section3_trend3:
    "Impacto global: La CBAM está presionando a los socios comerciales globales a establecer o adaptar sus propios mecanismos de precios del carbono",
  section3_trend4:
    "Desarrollo tecnológico: Las herramientas digitales y los sistemas automatizados están desempeñando un papel cada vez más importante en el conteo de emisiones de carbono",
  section4_title: "Cómo nuestro producto ayuda a las empresas",
  section4_content:
    "Nuestro producto puede ayudar a las empresas a cumplir efectivamente con los requisitos de la CBAM:",
  section4_benefit1:
    "Cálculos precisos: Proporciona cálculos precisos de emisiones de carbono basados en factores oficiales de la UE y factores personalizados",
  section4_benefit2:
    "Cumplimiento eficiente: Genera automáticamente informes compatibles con la CBAM y simplifica el proceso de declaración",
  section4_benefit3:
    "Procesamiento por lotes: Admite el procesamiento de grandes volúmenes de datos para mejorar la eficiencia laboral",
  section4_benefit4:
    "Integración API: Se integra fácilmente con sistemas ERP y e-commerce para informes automatizados de cumplimiento",
  download_title: "Descargar libro blanco ahora",
  email_placeholder: "Por favor ingrese su dirección de correo electrónico",
  agreement_text:
    "Acepto utilizar este correo electrónico para recibir el libro blanco y acepto procesar mis datos personales según los requisitos del RGPD.",
  privacy_policy: "Ver política de privacidad",
  download_button: "Descargar libro blanco (PDF)",
  download_generating: "Generando...",
  email_required: "Por favor ingrese su dirección de correo electrónico",
  agreement_required: "Por favor acepte la política de privacidad",
  download_success: "Libro blanco descargado con éxito, ¡gracias por usar nuestro servicio!",
  download_failed: "Error en la descarga, por favor intente nuevamente más tarde",
  submit_error: "Error al enviar, por favor intente nuevamente más tarde",
};
